import { Box } from '@chakra-ui/react';
import { TextRegular } from 'UiKit/typography';

export const studioText = {
  pageTitle: 'Studio Management',
};

export const formUpsertText = {
  roomLabel: 'Nama Ruangan',
  roomPlaceholder: 'Masukan nama ruangan',
  nameLabel: 'Nama Studio',
  namePlaceholder: 'Masukan nama studio',
  addressLabel: 'Alamat',
  addressPlaceholder: 'Masukan alamat studio',
  appTypeLabel: 'Tipe Aplikasi',
  appTypePlaceholder: 'Pilih tipe aplikasi',
  areaLabel: 'Area',
  areaPlaceholder: 'Pilih area',
  inlineErrorTitle: 'Terjadi kesalahan sistem',
  // Lo-Fi Master Data
  latitudeLabel: 'Latitude',
  latitudePlacholder: 'Masukan Latitude',
  longitudeLabel: 'Longitude',
  longitudePlaceholder: 'Masukan Longitude',
};

export const filterStudioText = {
  searchPlaceholder: 'Cari...',
  createStudioButtonText: 'Create Studio',
  areaPlaceholder: 'Pilih area',
  applicationTypePlaceholder: 'Pilih tipe aplikasi',
};

export const studioUpsertDomainText = {
  loadingTitle: 'Harap tunggu',
  loadingDescription: 'Sedang menyimpan studio...',
  successDescription: 'Studio berhasil disimpan',
  errorTitle: 'Gagal membuat studio',
  errorDescription: 'Terjadi kesalahan saat membuat studio. Silakan coba lagi atau periksa koneksi kamu.',
};

export const studioDeleteModalText = {
  loadingTitle: 'Harap tunggu',
  loadingDescription: 'Sedang menghapus studio...',
  successDescription: 'Studio berhasil dihapus',
  title: 'Yakin ingin menghapus studio ini?',
  errorTitle: 'Gagal menghapus studio',
  errorDescription: 'Terjadi kesalahan saat menghapus studio. Silakan coba lagi atau periksa koneksi kamu.',
  description: (
    <Box>
      <TextRegular>Menghapus studio akan berdampak pada data berikut:</TextRegular>
      <ul style={{ marginLeft: '32px' }}>
        <li>
          <TextRegular>Schedule akan tetap tersimpan, namun detail studio akan kosong.</TextRegular>
        </li>
        <li>
          <TextRegular>Data pencapaian studio yang terhubung dengan studio tersebut akan dihapus.</TextRegular>
        </li>
      </ul>
      <br />
      <TextRegular>Tindakan ini tidak bisa dibalikkan. Pastikan kamu yakin sebelum melanjutkan.</TextRegular>
    </Box>
  ),
  closeButton: 'Batal',
  submitButton: 'Ya, hapus sekarang',
};

export const studioCloseRestrictionText = {
  title: 'Yakin ingin membatalkan?',
  description: 'Perubahan yang telah kamu buat mungkin tidak akan tersimpan. Apakah kamu yakin ingin membatalkan?',
  closeButton: 'Tutup',
  submitButton: 'Ya, batalkan',
};
